import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  gap: 12,
  width: "100%",
  backgroundColor: "#fff",
  borderRadius: 8,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  border: "1px solid #f0f0f0",

  [theme.down("sm")]: {
    ...theme.paddings(20, 15),
  },
}));

export const Title = styled("h3")(({ theme }) => ({
  color: "#787878",
  borderBottom: "1px solid #ababab87",
  fontWeight: 400,
  paddingBottom: 10,
  margin: 0,
}));

export const Hint = styled("div")(({ theme }) => ({
  fontSize: 13,
  color: "#8a8a8a",
}));

export const OptionName = styled("div")(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  color: "#1a1a1a",
  marginTop: 6,
}));

export const Item = styled("div")(({ theme, $isSelected }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 12,
  padding: "10px 12px",
  border: `1px solid ${$isSelected ? theme.palette.searchButtonBg : "#e5e5e5"}`,
  borderRadius: 6,
  backgroundColor: $isSelected ? "rgba(230, 57, 70, 0.04)" : "#fff",
  transition: "all .2s ease-out",

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}));

export const ItemInfo = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 2,
  minWidth: 0,

  "& > .item__name": {
    fontSize: 14,
    fontWeight: 500,
    color: "#1a1a1a",
  },

  "& > .item__description": {
    fontSize: 12,
    color: "#8a8a8a",
  },

  "& > .item__price": {
    fontSize: 14,
    fontWeight: 600,
    color: "#0052ff",
  },
}));

export const ItemControls = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 8,
  flexShrink: 0,

  [theme.down("xs")]: {
    justifyContent: "flex-end",
  },
}));

export const QuantityButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 28,
  height: 28,
  border: "1px solid #ccc",
  borderRadius: 4,
  backgroundColor: "#fff",
  color: "#1a1a1a",
  fontSize: 16,
  cursor: "pointer",

  "&:disabled": {
    opacity: 0.4,
    cursor: "default",
  },
}));

export const Quantity = styled("span")(({ theme }) => ({
  minWidth: 20,
  textAlign: "center",
  fontSize: 14,
  fontWeight: 600,
}));

export const ToggleButton = styled("button")(({ theme, $isSelected }) => ({
  ...theme.mixins.flexCenterCenter,
  height: 32,
  padding: "0 12px",
  border: `1px solid ${theme.palette.searchButtonBg}`,
  borderRadius: 4,
  backgroundColor: $isSelected ? "transparent" : theme.palette.searchButtonBg,
  color: $isSelected ? theme.palette.searchButtonBg : theme.palette.white,
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all .2s ease-out",
  whiteSpace: "nowrap",

  "&:disabled": {
    opacity: 0.5,
    cursor: "default",
  },
}));

export const ErrorText = styled("div")(({ theme }) => ({
  fontSize: 13,
  color: "#dc2626",
}));

// --- услуги перевозчика (багаж): плечо → пассажир → варианты

export const SegmentTitle = styled("div")(({ theme }) => ({
  marginTop: 10,
  fontSize: 14,
  fontWeight: 600,
  color: "#4a4a4a",
}));

export const PassengerName = styled("div")(({ theme }) => ({
  marginTop: 8,
  fontSize: 13,
  color: "#8a8a8a",
}));

// у питания: блюдо, которое уже есть у пассажира в брони (включено в тариф)
export const CurrentChoice = styled("div")(({ theme }) => ({
  marginTop: 2,
  fontSize: 12,
  fontWeight: 400,
  color: "#8a8a8a",
}));

export const Chips = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginTop: 6,
}));

export const Chip = styled("button")(({ theme, $isSelected }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "flex-start",
  gap: 2,
  padding: "8px 12px",
  border: `1px solid ${$isSelected ? theme.palette.searchButtonBg : "#e5e5e5"}`,
  borderRadius: 6,
  backgroundColor: $isSelected ? "rgba(230, 57, 70, 0.06)" : "#fff",
  cursor: "pointer",
  textAlign: "left",
  transition: "all .2s ease-out",

  "& > .chip__name": {
    fontSize: 14,
    fontWeight: 500,
    color: "#1a1a1a",
  },

  "& > .chip__price": {
    fontSize: 13,
    fontWeight: 600,
    color: $isSelected ? theme.palette.searchButtonBg : "#0052ff",
  },

  "&:disabled": {
    opacity: 0.5,
    cursor: "default",
  },
}));

// --- выбор мест: сводка по рейсу и схема салона

export const SeatSummary = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 12,
  marginTop: 6,
  fontSize: 13,
  color: "#4a4a4a",

  [theme.down("xs")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}));

export const SeatToggle = styled("button")(({ theme }) => ({
  height: 32,
  padding: "0 12px",
  border: `1px solid ${theme.palette.searchButtonBg}`,
  borderRadius: 4,
  backgroundColor: "transparent",
  color: theme.palette.searchButtonBg,
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  whiteSpace: "nowrap",
}));

export const SeatMapBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  marginTop: 10,
  padding: 12,
  border: "1px solid #e5e5e5",
  borderRadius: 8,
  backgroundColor: "#fafbfc",
}));

export const SeatPassengerTabs = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
}));

export const SeatPassengerTab = styled("button")(({ theme, $isActive }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "flex-start",
  gap: 2,
  padding: "6px 10px",
  border: `1px solid ${$isActive ? theme.palette.searchButtonBg : "#d9dde3"}`,
  borderRadius: 6,
  backgroundColor: $isActive ? theme.palette.searchButtonBg : "#fff",
  color: $isActive ? theme.palette.white : "#1a1a1a",
  cursor: "pointer",
  textAlign: "left",

  "& > .tab__name": { fontSize: 13, fontWeight: 600 },
  "& > .tab__seat": { fontSize: 12, opacity: 0.85 },
}));

export const SeatLegend = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "6px 14px",
  fontSize: 12,
  color: "#4a4a4a",
}));

export const SeatLegendItem = styled("span")(({ theme, $color }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,

  "&::before": {
    content: '""',
    width: 12,
    height: 12,
    borderRadius: 3,
    backgroundColor: $color,
  },
}));

export const SeatScroll = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  gap: 4,
  maxHeight: 420,
  overflowY: "auto",
  padding: "4px 0",
}));

export const SeatRow = styled("div")(({ theme }) => ({
  position: "relative", // подпись ряда (аварийный выход) — абсолютно, чтобы не сдвигать ряд относительно остальных
  display: "flex",
  alignItems: "center",
  gap: 4,
}));

export const SeatRowNumber = styled("span")(({ theme, $isExit }) => ({
  width: 24,
  fontSize: 12,
  color: $isExit ? "#e08a1f" : "#8a8a8a", // ряд у аварийного выхода — на телефоне подпись ряда не влезает, остаётся цвет номера
  fontWeight: $isExit ? 700 : 400,
  textAlign: "right",
  marginRight: 4,
}));

export const SeatRowTag = styled("span")(({ theme }) => ({
  position: "absolute",
  left: "100%",
  top: "50%",
  transform: "translateY(-50%)",
  marginLeft: 8,
  fontSize: 11,
  color: "#8a8a8a",
  whiteSpace: "nowrap",

  [theme.down("xs")]: {
    display: "none",
  },
}));

export const SeatAisle = styled("span")(({ theme }) => ({
  width: 18,
}));

export const SeatButton = styled("button")(({ theme, $color, $isTaken, $isSelected, $isMine, $isEmpty }) => ({
  width: 30,
  height: 30,
  padding: 0,
  border: $isMine ? `2px solid ${theme.palette.searchButtonBg}` : "1px solid transparent",
  borderRadius: 6,
  backgroundColor: $isEmpty ? "transparent" : $isTaken ? "#d9dde3" : $isSelected ? "#1a1a1a" : $color,
  color: $isTaken ? "#9aa3ad" : "#fff",
  fontSize: 12,
  fontWeight: 600,
  cursor: $isTaken || $isEmpty ? "default" : "pointer",
  visibility: $isEmpty ? "hidden" : "visible",

  "&:disabled": {
    cursor: "default",
  },

  [theme.down("xs")]: {
    width: 26,
    height: 26,
  },
}));
